<template>
    <div class="page-guests">
        <el-card>
            <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="6" :xl="6" class="m-b-10 m-b-lg-0">
                    <el-date-picker
                            style="flex-grow: 2;"
                            @change="changeDate"
                            value-format="yyyy-MM-dd HH:mm"
                            format="dd/MM/yyyy HH:mm"
                            class="min-width-200 w-100 m-r-20"
                            v-model="form.Date"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="От"
                            end-placeholder="До"
                            :clearable="false"
                            :picker-options="{ firstDayOfWeek: 1 }"
                    >
                    </el-date-picker>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" class="m-b-10 m-b-lg-0">
                    <el-select filterable v-if="companyId == 0" v-model="form.CompanyName" placeholder="Отчет по клиенту" class="w-100" :clearable="true">
                        <el-option
                                v-for="row in companies"
                                :key="row.ID"
                                :label="row.Name"
                                :value="row.Name">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" class="m-b-10 m-b-md-0">
                    <el-select filterable :clearable="true" v-model="form.TariffName" placeholder="Выберите тариф" class="w-100" required>
                        <el-option
                                v-for="item in $tarifDict"
                                :key="item.ID"
                                :label="item.Name"
                                :value="item.Name">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :sm="24" :md="12" :lg="6" :xl="6" class="d-flex">
                    <el-button :icon="$mobile() ? 'icon-clock' : ''" class="w-50" type="default" @click="handleToday">
                        Сегодня
                    </el-button>
                    <el-button :icon="$mobile() ? 'icon-search' : ''" class="w-50" type="primary" @click="handleFilter">
                        {{ ($mobile() ? 'Обновить данные' : 'Обновить') }}
                    </el-button>
                </el-col>
            </el-row>
        </el-card>

        <report name="Guests" :form="form" :key="formKey" :autoFetch="autoFetch" />
    </div>
</template>

<script>
    import Vue from 'vue'
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                autoFetch: true,
                companyId: sessionStorage.getItem('companyId'),
                form: {
                    CompanyName: '',
                    TariffName: '',
                    Date: [
                        (sessionStorage.getItem('dateFrom') ? sessionStorage.getItem('dateFrom') : Vue.moment().format('YYYY-MM-DD 00:00')),
                        (sessionStorage.getItem('dateTo') ? sessionStorage.getItem('dateTo') : Vue.moment().add(1, 'day').format('YYYY-MM-DD 00:00'))
                    ]
                },
                companies: [],
                formKey: 0
            }
        },
        created () {
            this.getCompanies()
        },
        computed: {
            ...mapGetters(['user']),
        },
        methods: {
            render () {
                this.autoFetch = true
                this.formKey += 1;
            },
            getCompanies() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Company"
                }, this.form)

                this.$api.Main.getCompanies(request).then(response => {
                    this.companies = response.Items

                    // if (this.form.CompanyName === '') {
                    //     this.form.CompanyName = this.companies[0].Name
                    // }
                    // this.form.TariffName = this.$tarifDict[0].Name
                }).catch (() => {

                })
            },
            handleFilter () {
                this.render()
            },
            handleToday () {
                this.form.Date = this.$today
                this.render()
            },
            changeDate (date) {
                if (!date) {
                    this.form.Date = this.$today
                    sessionStorage.setItem('dateFrom', this.$today[0])
                    sessionStorage.setItem('dateTo', this.$today[1])
                }
                else {
                    sessionStorage.setItem('dateFrom', date[0])
                    sessionStorage.setItem('dateTo', date[1])
                }
                this.render()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.render()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.render()
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .guests {
        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .right {
                justify-content: flex-end;
            }
        }
        .el-card__body {
            padding: 0;
        }
    }
</style>
